"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.RESPONSIVE_MAX_CONSTRAINT = exports.columnUnit = exports.gridSubUnit = exports.gridUnit = void 0;

/**
 * The grid unit size in pixels
 * */
var gridUnit = 8;
exports.gridUnit = gridUnit;
var gridSubUnit = 4;
exports.gridSubUnit = gridSubUnit;
var columnUnit = gridUnit * 40;
/**
 * This is copied from here:
 *
 * https://github.com/OfficeDev/office-ui-fabric-react/blob/8a9e4e0253e75f941bb95c908d2bee7178c0bcbe/packages/office-ui-fabric-react/src/utilities/decorators/withResponsiveMode.tsx
 *
 * For or some reason Office UI Fabric doesn't export this constant or any
 * other programatic way to get their standard responsive widths.
 */

exports.columnUnit = columnUnit;
var RESPONSIVE_MAX_CONSTRAINT = [479, 639, 1023, 1365, 1919, 99999999];
exports.RESPONSIVE_MAX_CONSTRAINT = RESPONSIVE_MAX_CONSTRAINT;